/**
 * Dataset-wide defaults, so a record only carries what differs from them.
 *
 * The same mechanism as the gap list and the non-cash exceptions: state the
 * common case once, list the departures. Every distribution on file today is in
 * CAD, so carrying "CAD" 3,483 times says nothing.
 *
 * A default is not an assumption, though — the field stays in the shape and a
 * record may override it. That matters here specifically: eight USD unit
 * classes already quote their *prices* in USD, so the premise that everything
 * is Canadian is known to be temporary.
 */
export const DEFAULTS = {
    currency: 'CAD',
} as const;

/** Read a possibly-omitted field. */
export const withDefault = <K extends keyof typeof DEFAULTS>(value: string | null | undefined, field: K): string =>
    value ?? DEFAULTS[field];
